import React from "react"
import useGlobalTheme from "hooks/useGlobalTheme"

const Theme = () => {
  const theme = useGlobalTheme()

  const fonts = {
    barlow: "Barlow:ital,wght@0,400;0,500;0,700;1,400",
    ubuntu: "Ubuntu:ital,wght@0,400;0,500;0,700;1,400",
  }

  const font = theme?.mainFont?.value.toLowerCase() || "barlow"

  return (
    <>
      {fonts[font] && (
        <>
          <link rel="preconnect" href="https://fonts.googleapis.com" />
          <link
            rel="preconnect"
            href="https://fonts.gstatic.com"
            crossOrigin="anonymous"
          />
          <link
            href={`https://fonts.googleapis.com/css2?family=${fonts[font]}&display=swap`}
            rel="stylesheet"
          />
        </>
      )}
    </>
  )
}

export { Theme }
